export const environment = {
  production: false,
  apiBaseURL: 'https://demo-api.emma.knustconnect.de'
};
